import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type ChipVariantType, chipVariantList } from '../../typings/chipVariantType';
import { defaults } from '../defaults';

export const withChipVariantProps = {
  /**
   * Wariant chipsa
   */
  variant: {
    type: String as PropType<ChipVariantType>,
    default: defaults.button.variant
  }
};

/**
 * Zwraca klasę wariantu chipsa
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withChipVariantProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useChipVariantProps = (prefix: string, props: ExtractPropTypes<typeof withChipVariantProps>) => {
  return computed(() => ({
    [`${prefix}--${props.variant}`]: props.variant !== undefined
  }));
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesChipVariantArgs = {
  args: {
    variant: defaults.chip.variant
  },

  argTypes: {
    variant: {
      options: chipVariantList,
      control: { type: 'select' }
    }
  }
};
